import queryString from 'query-string';
import createHistory from 'history/createBrowserHistory';
import { lastProduct } from './cookies.js';

const history = createHistory();

function push(path, state) {
	if (!path) {
		console.warn('No location provided');
		return;
	}
	history.push(path, state);
}

function replace(path, state) {
	if (!path) {
		console.warn('No location provided');
		return;
	}
	history.replace(path, state);
}

function basePathname(path = '/') {
	return lastProduct() ? `/${lastProduct()}` : path;
}

function pushBack() {
	if (history.length > 1) {
		history.goBack();
		return;
	}
	push(basePathname());
}

function pushBasePathname() {
	push(basePathname());
}

history.listen((location) => {
	location = Object.assign(location,
		// parse the search string using your package of choice
		{ query: queryString.parse(location.search) }
	);
});

function parseQueryString(location) {
	if (location && location.query) {
		return location.query;
	} else if (location && location.search) {
		return queryString.parse(location.search);
	}
	return false;
}

export { history, push, replace, pushBack, basePathname, pushBasePathname, parseQueryString };



// WEBPACK FOOTER //
// ./mobile-core/src/store/history.js